import { getLocationsRetrieveQueryKey, useLocationsJobsPlanSwitchCreate } from "@sidegigllc/api/client";
import { useQueryClient } from "@tanstack/react-query";

/** Moves a pay-per-hire location onto the Jobs plan (trial or resubscribe, per the API), then refreshes its plan. */
export const useSwitchToJobsPlan = (locationId: number) => {
  const queryClient = useQueryClient();
  const switchPlan = useLocationsJobsPlanSwitchCreate();

  const mutateAsync = async () => {
    await switchPlan.mutateAsync({ locationId });
    await queryClient.invalidateQueries({ queryKey: getLocationsRetrieveQueryKey(locationId) });
  };

  return { mutateAsync };
};
